
const getStatus = (msed_id) => {
	if (msed_id === 1) return 'Зарегистрирована'
	if (msed_id === 2) return 'Рассмотрение'
	if (msed_id === 3) return 'Исполнение'
	if (msed_id === 4) return 'Закрыта'
	
	return ''
}

export default getStatus